

export const MESSAGE_SUCCESS = 'MESSAGE_SUCCESS'; 
export const MESSAGE_UPDATE  = 'MESSAGE_UPDATE';
export const MESSAGE_TOGGLE  = 'MESSAGE_TOGGLE'; //toggle by PID
export const MESSAGE_ERROR   = 'MESSAGE_ERROR';